<h1 mat-dialog-title>Exporteren ritten</h1>
<div mat-dialog-content>
  <form class="export-form" [formGroup]="exportForm">
    <mat-label class="dialog-subtitle">Periode</mat-label>
    <div class="date-filter">
      <mat-radio-group (change)="periodChange()" formControlName="selectedFilter" class="radio-group secondary-color">
        @for (filter of dateFilter; track filter) {
          <mat-radio-button [value]="filter.value">
            {{ filter.viewValue }}
          </mat-radio-button>
        }
      </mat-radio-group>
      <div class="select-fields">
        @if (
          exportForm.value.selectedFilter == 'year' ||
          exportForm.value.selectedFilter == 'month' ||
          exportForm.value.selectedFilter == 'week'
        ) {
          <mat-form-field [hideRequiredMarker]="true">
            <mat-label>Jaar</mat-label>
            <mat-select formControlName="year">
              @for (year of years(); track year) {
                <mat-option [value]="year.value">
                  {{ year.viewValue }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @if (exportForm.controls.selectedFilter.value == 'month') {
          <mat-form-field [hideRequiredMarker]="true">
            <mat-label>Maand</mat-label>
            <mat-select formControlName="month">
              @for (month of months; track month) {
                <mat-option [value]="month.value">
                  {{ month.viewValue }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @if (exportForm.controls.selectedFilter.value == 'week') {
          <mat-form-field [hideRequiredMarker]="true">
            <mat-label>Week</mat-label>
            <mat-select formControlName="week">
              @for (week of weeks(); track week) {
                <mat-option [value]="week">
                  {{ week }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @if (exportForm.controls.selectedFilter.value == 'day') {
          <mat-form-field [hideRequiredMarker]="true">
            <mat-label>Kies een datum</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="day" />
            <mat-datepicker-toggle matSuffix aria-label="Kalender openen" [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        }
      </div>
    </div>
    @if (characteristics.length > 0) {
      <div class="characteristics-filter">
        <mat-label class="dialog-subtitle">Kenmerken</mat-label>
        <div class="checkbox-group">
          @for (characteristic of characteristics; track characteristic) {
            <mat-checkbox
              class="group-checkbox"
              (change)="selectCharacteristic(characteristic.name)"
              [checked]="exportForm.value.selectedCharacteristics.indexOf(characteristic.name) != -1"
              >{{ characteristic.name }}
            </mat-checkbox>
          }
        </div>
      </div>
      @if (exportForm.value.selectedCharacteristics.length > 0) {
        <mat-error>Let op: alleen ritten met het geselecteerde kenmerk worden geëxporteerd.</mat-error>
      }
    }
    <mat-slide-toggle formControlName="exportFromAndTo"> Exporteer ophaal- en bestemmingsadres </mat-slide-toggle>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Annuleren</button>
  <button mat-flat-button [class.spinner]="exporting()" (click)="export()">Exporteer</button>
</div>
